// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_oj-0";
export var discountCodeInput = "_oj-1";